import moment from "moment";
import React from "react";
import { Form, Modal } from "react-bootstrap";

const AddShippingModal = ({
  trackingDetailModal,
  handleCloseTrackingModal,
  trackingData,
  errorMessageTracking,
  setErrorMessageTracking,
  productTrackingForm,
  setProductTrackingForm,
  handleAddTrackingAddres,
  handleTrackingStatusUpdate,
  trackingAlreadyData,
  setEditShipping,editShipping
}) => {
  return (
    <Modal
      show={trackingDetailModal}
      onHide={handleCloseTrackingModal}
      backdrop="static"
      className="ship-nmodal-main"
    >
      <Modal.Header className="add-address-close-icon" closeButton>
        <Modal.Title className="shipping-address-heading">
          Order Id: {trackingData?.obj?.OrderSummary?.OrderId}{" "}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form className="add-Address-main-container-co">
          <div>
            <h6 className="p-name-ship">
              Product Name : {trackingData?.item?.Name}
            </h6>
            <div className="item-status-ship">
              <p>Item Status : </p>{" "}
              <p className="order-status-ship"> {trackingData?.item?.Status}</p>
            </div>
            <hr></hr>
          </div>

          {editShipping ? (
            <>
              <div className="etime-deleverby">
                <Form.Group controlId="formDelivery" className="">
                  <Form.Label>Delivery Estimate Time</Form.Label>
                  <Form.Control
                    type="date"
                    value={moment(
                      productTrackingForm?.DeliveryEstimatedTime
                    ).format("YYYY-MM-DD")}
                    onChange={(e) => {
                      setProductTrackingForm({
                        ...productTrackingForm,
                        DeliveryEstimatedTime: e.target.value,
                      });
                      setErrorMessageTracking({
                        ...errorMessageTracking,
                        DeliveryEstimatedTime: "",
                      });
                    }}
                  />
                </Form.Group>
                <Form.Group controlId="formShippingBy" className="">
                  <Form.Label>Shipping By</Form.Label>
                  <Form.Control
                    type="text"
                    value={productTrackingForm?.ShippingBy}
                    onChange={(e) => {
                      setProductTrackingForm({
                        ...productTrackingForm,
                        ShippingBy: e.target.value,
                      });
                      setErrorMessageTracking({
                        ...errorMessageTracking,
                        ShippingBy: "",
                      });
                    }}
                  />
                </Form.Group>

                <Form.Group controlId="formTrackingNo">
                  <Form.Label>Phone No</Form.Label>
                  <Form.Control
                    type="text"
                    value={productTrackingForm?.PhoneNumber}
                    onChange={(e) => {
                      setProductTrackingForm({
                        ...productTrackingForm,
                        PhoneNumber: e.target.value,
                      });
                      setErrorMessageTracking({
                        ...errorMessageTracking,
                        PhoneNumber: "",
                      });
                    }}
                  />
                </Form.Group>

                <Form.Group controlId="formTrackingNo">
                  <Form.Label>Tracking No</Form.Label>
                  <Form.Control
                    type="text"
                    value={productTrackingForm?.TrackingNumber}
                    onChange={(e) => {
                      setProductTrackingForm({
                        ...productTrackingForm,
                        TrackingNumber: e.target.value,
                      });
                      setErrorMessageTracking({
                        ...errorMessageTracking,
                        TrackingNumber: "",
                      });
                    }}
                  />
                </Form.Group>
              </div>
            </>
          ) : (
            <div className="etime-deleverby">
              <Form.Group controlId="formDelivery" className="col-lg-3">
                <strong>Estimated Delivery time</strong>
                <p>
                  {moment(trackingAlreadyData?.DeliveryEstimatedTime).format(
                    "YYYY-MM-DD"
                  )}
                </p>
              </Form.Group>
              <Form.Group controlId="formShippingBy" className="col-lg-3">
                <strong>Shipping By</strong>
                <p>{trackingAlreadyData?.ShippingBy}</p>
              </Form.Group>

              <Form.Group controlId="formTrackingNo" className="col-lg-3">
                <strong>Phone No</strong>
                <p>{trackingAlreadyData?.PhoneNumber}</p>
              </Form.Group>

              <Form.Group controlId="formTrackingNo" className="col-lg-3">
                <strong>Tracking No</strong>
                <p>{trackingAlreadyData?.TrackingNumber}</p>
              </Form.Group>
            </div>
          )}
        </Form>
        {editShipping ? (
            <div className="row">
              <div className="col-lg-6 col-8">
                <div className="form-group mt-2">
                  <button
                    type="button"
                    className="common_btn view-data-btn"
                    onClick={() => {
                        handleAddTrackingAddres();
                      // handleStatusUpdate();
                    }}
                  >
                    Update Order With Shipping Detail
                  </button>
                </div>
              </div>
              <div className="col-lg-6 col-4">
                <div className="form-group mt-2">
                  <button
                    type="button"
                    className="common_btn btn-primary pull-right"
                    onClick={() => setEditShipping(false)}
                  >
                    Back
                  </button>
                </div>
              </div>
            </div>
          ) : trackingAlreadyData &&
            trackingAlreadyData?.Status !== "Delivered" &&
            trackingAlreadyData?.Status !== "Cancel" ? (
            <button
              type="button"
              className="common_btn btn-primary mt-2"
              onClick={() => setEditShipping(true)}
            >
              Edit Shipping Detail &amp; Order Status Update
            </button>
          ) : null}
        {editShipping ? (
        <div className="etime-deleverby">
          <Form.Group controlId="formDelivery" className="col-lg-3">
            <strong>Estimated Delivery time</strong>
            <p>
              {moment(trackingAlreadyData?.DeliveryEstimatedTime).format(
                "YYYY-MM-DD"
              )}
            </p>
          </Form.Group>
          <Form.Group controlId="formShippingBy" className="col-lg-3">
            <strong>Shipping By</strong>
            <p>{trackingAlreadyData?.ShippingBy}</p>
          </Form.Group>

          <Form.Group controlId="formTrackingNo" className="col-lg-3">
            <strong>Phone No</strong>
            <p>{trackingAlreadyData?.PhoneNumber}</p>
          </Form.Group>

          <Form.Group controlId="formTrackingNo" className="col-lg-3">
            <strong>Tracking No</strong>
            <p>{trackingAlreadyData?.TrackingNumber}</p>
          </Form.Group>
        </div>
      ) : null}
      </Modal.Body>
      {/* {!editShipping ? (
      <Modal.Footer className="Add-address-modal-save-button-ship">
        {prefiledData?.Status == "Delivered" ? (
          <p style={{ color: "#198754", marginTop: "10px" }}>Delivered!</p>
        ) : (
          <Button
            className="view-data-btn-ship"
            variant="primary"
            onClick={handleConfirmDelivery}
          >
            Order Shipping Status Update (Confirm When Order is Delivered)
          </Button>
        )}
      </Modal.Footer>
    ) : null} */}
    </Modal>
  );
};

export default AddShippingModal;
